var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 147,
    height: 43,
    viewBox: "0 0 147 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M115.72 36.0358H115.12V36.6358V41.69H10.0267L0.6 29.9954V0.6H136.973L146.4 12.2946V41.69H134.276L131.356 36.348L131.185 36.0358H130.829H115.72Z",
    fill: "url(#paint0_radial_11331_16403)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M115.72 36.0358H115.12V36.6358V41.69H10.0267L0.6 29.9954V0.6H136.973L146.4 12.2946V41.69H134.276L131.356 36.348L131.185 36.0358H130.829H115.72Z",
    fill: "url(#paint1_radial_11331_16403)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M115.72 36.0358H115.12V36.6358V41.69H10.0267L0.6 29.9954V0.6H136.973L146.4 12.2946V41.69H134.276L131.356 36.348L131.185 36.0358H130.829H115.72Z",
    stroke: "url(#paint2_linear_11331_16403)",
    strokeWidth: 1.2,
    strokeLinecap: "square"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M117.797 39.7023L120.184 41.224L121.779 40.2158V42.0207H122.564V39L120.184 40.5104L117.797 39V39.7023Z",
    fill: "#F2DD1C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M122.842 41.9792V42.0207H126.014V41.5147H123.634L122.842 41.9792ZM122.842 39L123.634 39.506H126.014V39H122.842ZM122.842 40.2611V40.7633H123.634H126.014V40.2611H123.634H122.842Z",
    fill: "#F2DD1C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M126.626 39V39.506V42.0207H127.423V39.506H129.007V39H126.626Z",
    fill: "#F2DD1C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M129.817 41.0163L130.519 40.129L131.215 41.0163H132.108L130.519 39L128.138 42.0207H129.019L129.424 41.5147L129.817 41.0163ZM132.501 41.5185H131.62L132.013 42.0207H132.9L132.501 41.5185Z",
    fill: "#F2DD1C"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_11331_16403",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(76.0929 1.50008) rotate(90) scale(21.9144 302.319)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3DD11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#272421",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_11331_16403",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(73.7516 42.1461) rotate(-90) scale(19.6449 131.902)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3DD11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#272421",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_11331_16403",
    x1: 73.4999,
    y1: 42.2898,
    x2: 73.4999,
    y2: 0.000030248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2DD1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2DD1C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSell);
export default __webpack_public_path__ + "static/media/Sell.5e2e758bc87ae71dbe3684cd0b701b2d.svg";
export { ForwardRef as ReactComponent };